/**
 * Documents Compressor - /documents category page
 * Accepts: PDF, DOCX, PPTX, XLSX
 */
import { createApp } from 'vue';
import DocumentsCompressor from '@/Components/DocumentsCompressor.vue';
import '@styles/app.css';

createApp(DocumentsCompressor).mount('#documents-compressor');
